// extracted by extract-css-chunks-webpack-plugin
module.exports = {"link":"tax-deductible-funds-panel__link___16h1B"};
    if(module.hot) {
      // 1701915839339
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  